import { CSSProperties } from 'react';

export const bannerContainerStyle: CSSProperties = {
  borderRadius: '20px',
  marginTop: '10px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 15px',
  justifyContent: 'space-between',
  boxShadow: '0 0 1px rgba(0, 0, 0, 0.25)'
};

export const bannerIconWrapperStyle: CSSProperties = {
  width: '37px',
  height: '37px',
  background: '#000',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%'
};

export const textContainerStyle: CSSProperties = {
  marginLeft: '9px'
};
